//
// --------- Trigger other functions depending on the window resize:
// -----------------------------------------------------------------
// -----------------------------------------------------------------

function minWidth(width, fc1, fc2) {
    fc2 = fc2 || (function(){});
    if (ww >= width) {
        fc1();
    } else {
        fc2();
    }
}

// screenMd et screenSm sont définies dans variables.js

function checkWindowWidth(fc1, fc2, fc3) {
    fc1 = fc1 || (function(){});
    fc2 = fc2 || (function(){});
    fc3 = fc3 || (function(){});

    if (ww <= sm) {
        fc1();
    } else if ((ww <= md)) {
        fc2();
    } else {
        fc3();
    }
}

// function fontInput(){
// 	$('input, select').on('focus', function(){
//       // replace CSS font-size with 16px to disable auto zoom on iOS
//       $(this).data('fontSize', $(this).css('font-size')).css('font-size', '16px');
//     }).on('blur', function(){
//       // put back the CSS font-size
//       $(this).css('font-size', $(this).data('fontSize'));
//     });
// };


//
// --------- Add one or more of the above functions,
// --------- then add update as an argument to window.resize():
// ------------------------------------------------------------
// ------------------------------------------------------------

// function update(){
//     /* Put code here */
// }

//
// --------- Update all variables needed:
// --------------------------------------
// --------------------------------------

// function updateVariables() {
//     wh = $window.height();
//     ws = $window.scrollTop();
//     /* Others */
// }


//
// --------- Anchor link of the current block get a class "active":
// ----------------------------------------------------------------
// -------------------------------------------- need to be reviewed
// ----------------------------------------------------------------


//
// Module 
// function linkActive(){
//     $section.each(function(){
//         anchor_id  = $(this).find('.js-anchor').attr('id');
//         section_os = $(this).find('.js-anchor').offset().top;
//         if (ws >= section_os - 1) {
//             $('.js-scroll-to').removeClass('active');
//             $('.js-scroll-to[data-scroll-to=' + anchor_id + ']').addClass('active');
//         }
//     });
// }

